import qs from 'query-string'
import { paths } from '@/constants/paths'
import { logger } from './logging'

export interface BuildLoginUrlOptions {
  returnTo: string
  email?: string
}

export const buildLoginUrl = (returnToOrOptions: string | BuildLoginUrlOptions): string => {
  const options: BuildLoginUrlOptions =
    typeof returnToOrOptions === 'string' ? { returnTo: returnToOrOptions } : returnToOrOptions

  const hashed = Buffer.from(options.returnTo, 'utf-8').toString('base64')

  const queryParams: Record<string, string> = {
    returnTo: hashed,
  }

  if (options.email) {
    queryParams.email = options.email
  }

  // Use query-string library to match server-side encoding behavior
  return `${paths.auth.login}?${qs.stringify(queryParams)}`
}

export const buildLogoutUrl = (returnTo?: string): string => {
  if (returnTo) {
    // Prevent creating recursive logout URLs - don't encode a logout URL as returnTo
    if (returnTo.includes('/auth/logout')) {
      return paths.auth.logout
    }
    const hashed = Buffer.from(returnTo, 'utf-8').toString('base64')
    return `${paths.auth.logout}?${qs.stringify({ returnTo: hashed })}`
  } else {
    return paths.auth.logout
  }
}

export const parseReturnToParam = (
  encodedReturnTo: string | undefined,
  fallbackUrl: string,
  protocol: string,
  host: string,
): string => {
  if (!encodedReturnTo) {
    return fallbackUrl
  }

  try {
    const decodedReturnTo = decodeURIComponent(encodedReturnTo)
    const parsed = Buffer.from(decodedReturnTo, 'base64').toString('utf-8')
    const candidateURL = parsed.startsWith('http') ? parsed : `${protocol}://${host}${parsed}`

    // Prevent redirect loops - don't allow returnTo to point back to logout
    const candidateURLObj = new URL(candidateURL)
    if (candidateURLObj.pathname.includes('/auth/logout')) {
      logger().warn('Prevented logout redirect loop', { returnTo: encodedReturnTo, parsed })
      return fallbackUrl
    }

    return candidateURL
  } catch (error) {
    logger().error('Error parsing returnTo', { error, returnTo: encodedReturnTo })
    return fallbackUrl
  }
}
